<script setup lang="ts">
import type { GridColumnProps } from '@progress/kendo-vue-grid'
import { formatCurrency } from '@/lib/format'
import CardTableContent from '@/components/ui/card/CardTableContent.vue'
import Card from '@/components/ui/card/Card.vue'
import RepartitionFormationRepository from '@/repository/RepartitionFormationRepository'

const columns = [
  { field: 'type_formation', title: 'Type de formation' },
  { field: 'agence_name', title: 'Agence' },
  { field: 'catalogue_name', title: 'Catalogue' },
  { field: 'nb_formations', title: 'Nb formations' },
  { field: 'nb_apprenants', title: 'Nb apprenants' },
  { field: 'chiffre_affaire', title: "Chiffre d'affaire" },
] as GridColumnProps[]

const formatCell = (field: string, value: string) => {
  if (field === 'chiffre_affaire') {
    return formatCurrency(value as unknown as number)
  }
  return value
}

const getData = async (
  skip: number,
  take: number,
  //sortField: string,
  //sortOrder: 'asc' | 'desc',
) => {
  const response = await RepartitionFormationRepository.getTableData(
    skip,
    take,
    // sortField,
    // sortOrder,
  )
  return {
    data: response.data,
    total: response.total,
  }
}
</script>

<template>
  <Card
    title="Détails des formations"
    :download-excel="RepartitionFormationRepository.downloadExcel"
  >
    <CardTableContent
      :columns="columns"
      :get-data="getData"
      :format-cell="formatCell"
      :initial-sort="{ field: 'type_formation', dir: 'asc' }"
    />
  </Card>
</template>
